export default __webpack_public_path__ + "static/media/signupimage.3fc8b61a.jpeg";